import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import IdentityApprovalConfirm from './IdentityApprovalConfirm';
import { getIdentities, editIdentityStatus } from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  itemDiv: {
    margin: '20px auto'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getIdentities, editIdentityStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isApprovalSuccess', 'updateIsApprovalSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('document', 'setDocument', ''),
  withState('identityType', 'setIdentityType', 0),
  withState('approvalResult', 'setApprovalResult', 'CONFIRMED'),
  withState('approvalResultStr', 'setApprovalResultStr', '審査OK'),
  withState('shopFoodApproved', 'setShopFoodApproved', 1),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState(
    'shopFoodApprovedResultStr',
    'setShopFoodApprovedResultStr',
    '飲食店'
  ),
  withState('ngReason', 'setNgReason', ''),
  withState('adminMemo', 'setAdminMemo', ''),
  withState('status', 'setStatus', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      const shopFoodApproved =
        this.props.detail.shopFoodApproved !== null
          ? this.props.detail.shopFoodApproved
          : this.props.detail.shopFood;
      this.props.setShopFoodApproved(
        this.props.detail.status !== null &&
          this.props.detail.status === 'UNCONFIRMED'
          ? this.props.detail.shopFood
          : shopFoodApproved
      );
      this.props.setAdminMemo(this.props.detail.adminMemo);
      this.props.setNgReason(this.props.detail.ngReason);
      if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'CONFIRMED'
      ) {
        this.props.setApprovalResult('CONFIRMED');
        this.props.setApprovalResultStr('審査OK');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'RESERVED'
      ) {
        this.props.setApprovalResult('RESERVED');
        this.props.setApprovalResultStr('確認中（保留中）');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'REJECTION'
      ) {
        this.props.setApprovalResult('REJECTION');
        this.props.setApprovalResultStr('再提出依頼');
      } else if (
        this.props.detail.status !== null &&
        this.props.detail.status === 'NG'
      ) {
        this.props.setApprovalResult('NG');
        this.props.setApprovalResultStr('審査NG');
      }
      if (this.props.detail.bankAccountHolder) {
        this.props.setBankAccountHolder(this.props.detail.bankAccountHolder);
      }
      console.log(this.props.detail);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    detail,
    updateOpenApprovalModal,
    openApprovalConfirmModal,
    updateOpenApprovalConfirmModal,
    searchKey,
    openApprovalProgress,
    updateOpenApprovalProgress,
    loading,
    updateLoading,
    isApprovalSuccess,
    updateIsApprovalSuccess,
    resultMessage,
    setResultMessage,
    approvalResult,
    setApprovalResult,
    shopFoodApproved,
    // setShopFoodApproved,
    approvalResultStr,
    setApprovalResultStr,
    shopFoodApprovedResultStr,
    setShopFoodApprovedResultStr,
    ngReason,
    setNgReason,
    adminMemo,
    setAdminMemo,
    bankAccountHolder,
    setBankAccountHolder
  }) => {
    const editConfirm = {
      approvalResultStr,
      ngReason,
      adminMemo,
      bankAccountHolder,
      shopFoodApprovedResultStr
    };
    const editParam = {
      approvalResult,
      ngReason,
      adminMemo,
      bankAccountHolder,
      shopFoodApproved: parseInt(shopFoodApproved, 10)
    };

    const isConfirm = detail.status !== null && detail.status === 'CONFIRMED';

    const convertApprovalResultStr = mode => {
      if (mode === 'CONFIRMED') {
        setApprovalResultStr('審査OK');
      } else if (mode === 'RESERVED') {
        setApprovalResultStr('確認中（保留中）');
      } else if (mode === 'REJECTION') {
        setApprovalResultStr('再提出依頼');
      } else if (mode === 'NG') {
        setApprovalResultStr('審査NG');
      }
    };

    const convertShopFoodApprovedResultStr = mode => {
      if (mode === '1') {
        setShopFoodApprovedResultStr('飲食店');
      } else {
        setShopFoodApprovedResultStr('飲食店以外');
      }
    };

    const cancelAction = () => updateOpenApprovalModal(false);
    const confirmAction = () => {
      updateOpenApprovalConfirmModal(true);
      convertShopFoodApprovedResultStr(shopFoodApproved.toString());
    };
    const backAction = () => updateOpenApprovalConfirmModal(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenApprovalProgress(true);
      const editedStatus = await actions
        .editIdentityStatus(detail.identityId, editParam)
        .then(data => checkSession(data));
      if (editedStatus.type === 'EDIT_IDENTITY_STATUS_SUCCESS') {
        updateIsApprovalSuccess(true);
        await actions.getIdentities(searchKey).then(data => checkSession(data));
        setResultMessage('更新が完了しました。');
        updateLoading(false);
      } else {
        updateIsApprovalSuccess(false);
        setResultMessage('更新に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isApprovalSuccess) {
        updateOpenApprovalConfirmModal(false);
        updateOpenApprovalModal(false);
        updateOpenApprovalProgress(false);
      } else {
        updateOpenApprovalProgress(false);
      }
    };

    console.log('===================', shopFoodApproved);

    const registeredCopies =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages
            .filter(item => item.registeredCopy)
            .map(item => item.registeredCopy)
        : [];
    const sealCertificates =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages
            .filter(item => item.sealCertificate)
            .map(item => item.sealCertificate)
        : [];
    const others =
      detail.identityImages && detail.identityImages.length > 0
        ? detail.identityImages &&
          detail.identityImages.filter(item => item.other)
        : [];

    console.log('IMAGES: ', detail, registeredCopies, sealCertificates, others);

    return (
      <div className={classes.root}>
        <Typography variant="h6">本人確認書類審査</Typography>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            ①【必須】営業許可証
          </Typography>
          {others.length > 0 &&
            others.map(item => (
              <Card className={classes.document}>
                <CardActionArea>
                  <CardMedia component="img" image={item.other} />
                </CardActionArea>
              </Card>
            ))}
          {others.length === 0 && <Typography>アップロードなし</Typography>}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            ②【必須】印鑑証明/公共料金の領収書/身分証明書
          </Typography>
          {sealCertificates.length > 0 &&
            sealCertificates.map(item => (
              <Card className={classes.document}>
                <CardActionArea>
                  <CardMedia component="img" image={item} />
                </CardActionArea>
              </Card>
            ))}
          {sealCertificates.length === 0 && (
            <Typography>アップロードなし</Typography>
          )}
        </div>
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            ③ 振込先銀行通帳の1ページ目
          </Typography>
          {registeredCopies.length > 0 &&
            registeredCopies.map(item => (
              <Card className={classes.document}>
                <CardActionArea>
                  <CardMedia component="img" image={item} />
                </CardActionArea>
              </Card>
            ))}
          {registeredCopies.length === 0 && (
            <Typography>アップロードなし</Typography>
          )}
        </div>
        {registeredCopies.length > 0 && (
          <div className={classes.itemDiv}>
            <Typography variant="p" color="textPrimary">
              ④【任意】登記簿謄本
            </Typography>
            <Card className={classes.document}>
              <CardActionArea>
                <CardMedia component="img" image={detail.citizenIdentityCard} />
              </CardActionArea>
            </Card>
          </div>
        )}
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            連絡欄
          </Typography>
          {detail.note && <Typography>{detail.note}</Typography>}
          {!detail.note && <Typography>なし</Typography>}
        </div>
        {!isConfirm ? (
          <React.Fragment>
            <Divider />
            <div className={classes.itemDiv}>
              <RadioGroup
                row
                value={approvalResult}
                onChange={e => {
                  setApprovalResult(e.target.value);
                  convertApprovalResultStr(e.target.value);
                }}
              >
                <FormControlLabel
                  value="CONFIRMED"
                  control={<Radio color="primary" />}
                  label="審査OK"
                />
                <FormControlLabel
                  value="RESERVED"
                  control={<Radio color="primary" />}
                  label="確認中（保留中）"
                />
                <FormControlLabel
                  value="REJECTION"
                  control={<Radio color="primary" />}
                  label="再提出依頼"
                />
                <FormControlLabel
                  value="NG"
                  control={<Radio color="primary" />}
                  label="審査NG"
                />
              </RadioGroup>
            </div>
            <div className={classes.itemDiv}>
              <TextField
                label="NG理由"
                multiline
                rows="4"
                value={ngReason}
                fullWidth
                className={classes.textFieldLong}
                margin="normal"
                onChange={e => {
                  setNgReason(e.target.value);
                }}
              />
            </div>
            <div className={classes.itemDiv}>
              <TextField
                label="事務局メモ"
                multiline
                value={adminMemo}
                rows="4"
                fullWidth
                className={classes.textFieldLong}
                margin="normal"
                onChange={e => {
                  setAdminMemo(e.target.value);
                }}
              />
            </div>
          </React.Fragment>
        ) : (
          <div className={classes.itemDiv}>
            <Typography variant="p" color="textPrimary">
              事務局メモ
            </Typography>
            {detail.adminMemo && <Typography>{detail.adminMemo}</Typography>}
            {!detail.adminMemo && <Typography>なし</Typography>}
          </div>
        )}
        {/* <React.Fragment>
          <div className={classes.itemDiv}>
            <Typography variant="p" color="textPrimary">
              店舗種別
            </Typography>
            <RadioGroup
              row
              value={shopFoodApproved}
              onChange={e => {
                setShopFoodApproved(parseInt(e.target.value, 10));
                convertShopFoodApprovedResultStr(e.target.value);
              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio color="primary" />}
                label="飲食店"
              />
              <FormControlLabel
                value={0}
                control={<Radio color="primary" />}
                label="飲食店以外"
              />
            </RadioGroup>
          </div>
          <Divider className={classes.itemDiv} />
        </React.Fragment> */}
        <div className={classes.itemDiv}>
          <Typography variant="p" color="textPrimary">
            メールアドレス
          </Typography>
          <br />
          <Typography>{detail.email}</Typography>
          <br />
          <br />
          <Typography variant="p" color="textPrimary">
            電話番号
          </Typography>
          <br />
          <Typography>{detail.phone}</Typography>
          <br />
          <br />
          <Typography variant="p" color="textPrimary">
            法人番号
          </Typography>
          <br />
          <Typography>{detail.numberIdentity}</Typography>
        </div>
        <div className={classes.itemDiv}>
          <TextField
            label="口座名義"
            value={bankAccountHolder}
            rows="1"
            fullWidth
            className={classes.textFieldLong}
            margin="normal"
            onChange={e => {
              setBankAccountHolder(e.target.value);
            }}
          />
        </div>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openApprovalConfirmModal}>
          <IdentityApprovalConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={editConfirm}
            openApprovalProgress={openApprovalProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
